'use strict';

export default class BasketActions {
    constructor() {
        this.generateActions(
            'loadBasketsSuccess',
            'addToBasketSuccess',
            'loadSingleBasketsSuccess',
            'createBasketSuccess',
            'editBasketNameSuccess',
            'deleteBasketItemSuccess',
            'shareBasketsSuccess',
            'requestLicensingSuccess',
            'toggleDownload',
            'toggleDownloadAll',
            'toggleLicensing',
            'toggleLicensingAll',
            'updateLicensingUsageText',
            'setSingleBasket',
            'deleteBasketsBySelection',
            'deleteBasketsSuccess',
            'toggleBasketSelection',
            'resetShareUrl',
            'loadError'
        );
    }
}



// WEBPACK FOOTER //
// ./app/actions/basketActions.js